import AvatarFeatures from '../AvatarFeatures';

/**
 * Handles the LocalStorage for the selected avatar options
 */
export default class LocalStorage {
  private static readonly _selectedOptionsKey = 'selectedOptions';

  static get selectedOptions(): AvatarFeatures | null {
    const item = localStorage.getItem(LocalStorage._selectedOptionsKey);
    if (item) {
      const parsedItem = JSON.parse(item);
      return new AvatarFeatures(
        parsedItem._baseSprite,
        parsedItem._hairColor,
        parsedItem._skinColor,
        parsedItem._accessories,
      );
    }
    return null;
  }

  static set selectedOptions(value: AvatarFeatures | null) {
    if (value) {
      localStorage.setItem(LocalStorage._selectedOptionsKey, JSON.stringify(value));
    } else {
      localStorage.clear();
    }
  }
}
